function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M410.013211 409.999908c0 30.013571 26.478048 53.589522 66.603931 63.099107l0-129.704061C436.491259 352.905562 410.013211 379.987361 410.013211 409.999908zM546.727942 679.924547c40.125883-9.508561 70.109778-36.59036 70.109778-66.604954 0-30.012547-29.983895-53.590546-70.109778-63.099107L546.727942 679.924547zM511.672542 62.955844c-247.812015 0-448.703395 200.89138-448.703395 448.702372 0 247.813039 200.89138 448.705442 448.703395 448.705442 247.812015 0 448.704418-200.892403 448.704418-448.705442C960.375937 263.847224 759.484557 62.955844 511.672542 62.955844zM683.441651 613.319593c0 66.791196-57.945737 123.919311-136.714731 136.714731l0 38.560224-70.109778 0 0-38.560224c-78.768995-12.794397-136.714731-69.923536-136.714731-136.714731l70.109778 0c0 30.013571 26.478048 57.095369 66.603931 66.604954L476.616118 543.209816c-78.768995-12.794397-136.714731-66.417689-136.714731-133.208884s57.945737-123.919311 136.714731-136.714731l0-38.560224 70.109778 0 0 38.560224c78.768995 12.794397 136.714731 69.923536 136.714731 136.714731l-70.109778 0c0-30.012547-26.478048-57.094346-66.603931-66.604954l0 136.714731C625.495914 492.90613 683.441651 546.528398 683.441651 613.319593z",
  "p-id": 7578
});

function SvgBuessiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1632295136214,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7577,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuessiness);
export default __webpack_public_path__ + "static/media/buessiness.bda8d822.svg";
export { ForwardRef as ReactComponent };